import i18n from "i18next";
import { faFolder } from "@fortawesome/pro-regular-svg-icons";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { CatalogPartsView } from "src/components/views/erp/parts/catalogPart/CatalogPartsView.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenCatalogPartButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	catalogPartId: number | null | undefined;
}

export const OpenCatalogPartButton = ({ catalogPartId, variant = "menu", ...props }: OpenCatalogPartButtonProps) => {
	const { openDialog } = useGenericDialog();
	if (catalogPartId == null) return null;

	return (
		<AsyncButton
			label={i18n.t("open_catalog_part")}
			icon={faFolder}
			variant={variant}
			onClick={() => {
				openDialog({
					title: i18n.t("catalog_part"),
					size: "fullscreen",
					agentContext: {
						key: defineAgentUiContextKey("erp.parts.catalogPart.dialog"),
						data: { catalogPartId },
						pathSegments: [`${i18n.t("catalog_part")} ${catalogPartId}`],
					},
					content: <CatalogPartsView catalogPartId={catalogPartId} />,
				});
			}}
			{...props}
		/>
	);
};
